import Model from '../orm/Model'

export default class SchoolClosure extends Model {

    static entity = 'school_closures'

    static fields() {
        return {
            id: this.attr(null),
            school_id: this.attr(null),
            title: this.attr(''),
            start_date: this.attr( new Date() ),
            end_date: this.attr( new Date() )
        }
    }

    static graphql = {
        create: {
            type: 'createClosure',
            parameters: {
                title: 'String!',
                start_date: 'String!',
                end_date: 'String!'
            }
        },
    }
}